import EmployeesProvider from "providers/EmployeesProvider"
import EmployeesTamplate from "components/templates/EmployeesTemplate"

const Employee = () => {
  return (
    <EmployeesProvider>
      <EmployeesTamplate />
    </EmployeesProvider>
  )
}

export default Employee

